import { client } from "shared/helpers/client";

// --- Types ---
export interface Category {
  id: number;
  name: string;
}

export interface FieldOption {
  id: number;
  name: string;
}

export interface CategoryField {
  id: string;
  name: string;
  dataType: string;
  isMandatory: boolean;
  isMultiple: boolean;
  lstofdata: FieldOption[] | null;
}

export interface RequestItem {
  id: number;
  title: string;
  description: string;
  stage: string;
  creationDate: string;
  updatedDate: string;
  movedDate: string | null;
  dt: string;
}

export interface CommentRaw {
  comment?: string;
  Comment?: string;
  isforCustomer: boolean;
  createdTime: string;
  files?: CommentFileRaw[];
  Files?: CommentFileRaw[];
}

export interface CommentFileRaw {
  url?: string;
  URL?: string;
  fileName?: string;
  FileName?: string;
  fileExtension?: string;
  FileExtension?: string;
}

export interface Comment {
  comment: string;
  isforCustomer: boolean;
  createdTime: string;
  files: CommentFile[];
}

export interface CommentFile {
  url: string;
  fileName: string;
  fileExtension: string;
}

function normalizeComment(raw: CommentRaw): Comment {
  const rawFiles = raw.files || raw.Files || [];
  return {
    comment: raw.comment || raw.Comment || "",
    isforCustomer: raw.isforCustomer,
    createdTime: raw.createdTime,
    files: rawFiles.map((f) => ({
      url: f.url || f.URL || "",
      fileName: f.fileName || f.FileName || "",
      fileExtension: f.fileExtension || f.FileExtension || "",
    })),
  };
}

// --- API Calls ---

export async function getCategories(): Promise<Category[]> {
  const { response, error }: any = await client("/api/Bitrix/GetChatCategories");
  if (error) throw error;
  return response ?? [];
}

export async function getCategoryFields(id: number): Promise<CategoryField[]> {
  const { response, error }: any = await client("/api/Bitrix/GetCategoryByid", {
    params: { id },
  });
  if (error) throw error;
  return response ?? [];
}

export async function sendRequest(categoryId: number, fields: Record<string, any>) {
  const { response, error }: any = await client("/api/Bitrix/SendRequest", {
    params: { id: categoryId },
    data: { fields },
  });
  if (error) throw error;
  return response;
}

export async function getRequestsByCategory(categoryId: number, page: number = 0): Promise<RequestItem[]> {
  const { response, error }: any = await client("/api/Bitrix/GetRequestsByCategoryId", {
    params: { id: categoryId, Pagention: page },
  });
  if (error) throw error;
  return response ?? [];
}

export async function addComment(typeId: number, itemId: number, description: string, files: string[][] = []) {
  const { response, error }: any = await client("/api/Bitrix/AddComment", {
    data: { typeId, itemId, description, files },
  });
  if (error) throw error;
  return response;
}

export async function getComments(itemId: number, chatId: number): Promise<Comment[]> {
  const { response, error }: any = await client("/api/Bitrix/GetAllCommnetsByID", {
    params: { ItemID: itemId, ChatID: chatId },
  });
  if (error) throw error;
  const raw: CommentRaw[] = response ?? [];
  return raw.map(normalizeComment);
}
